import { render, staticRenderFns } from "./GroupTeamsSubItem.vue?vue&type=template&id=2fa68aff&"
import script from "./GroupTeamsSubItem.vue?vue&type=script&lang=js&"
export * from "./GroupTeamsSubItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupTeamsSubItem.vue?vue&type=style&index=0&id=2fa68aff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports